module.exports = __webpack_public_path__ + "img/pro_feature_google_maps_search.33c4bdb.png";